<template>
  <!-- echart表格 -->
  <div :style="echartStyle" ref="wmsChart"></div>
</template>

<script>
  // 引入echarts
  import echarts from 'echarts'

  export default {
    name: 'WMSEcharts',
    props: {
      echartStyle: {
        type: Object,
        default() {
          return {}
        }
      },
      chartOption: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(function() {
        if (this.chartOption.length === 0) {
          return
        }
        this.draw(this.$refs.wmsChart)
      })
    },
    watch: {
      chartOption: function(val) {
        this.draw(this.$refs.wmsChart)
      }
    },
    methods: {
      draw(element) {
        this.charts = echarts.init(element)
        this.charts.setOption(this.chartOption)
      }
    }
  }
</script>